import React from 'react'
import useCssVars from './useCssVars';


const withUseCssVars = Component => props => {
	const headStyleTagExist = document.getElementById('pmkino-custom-css-styles');

	if(!headStyleTagExist) {
		const myVariables = useCssVars()
		const headTag = document.getElementsByTagName('head')[0];
		const styleTag = document.createElement("style");
		styleTag.id = "pmkino-custom-css-styles"
	
		let cssString = ''
		_.keys(myVariables).map(varKey => {
			const value = myVariables[varKey]
	
			cssString = cssString + varKey + ":" + value + ";"
		})
	
		styleTag.innerHTML = `
			:root {
			${cssString}
			}
		`;
	
		headTag.appendChild(styleTag);
	}

	return <Component
		{...props}
	/>
}

export default withUseCssVars